import { featuresData } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1024px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-star-line"></i>
              核心优势
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              平台特色
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              为什么千万吃瓜群众选择51吃瓜网
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuresData.map((feature) => (
              <div
                key={feature.id}
                className="flex flex-col items-center text-center p-7 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div
                  className={`w-16 h-16 md:w-18 md:h-18 rounded-2xl flex items-center justify-center mb-5 ${
                    feature.color === 'primary'
                      ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                      : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                  } transition-all duration-300`}
                >
                  <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}